/**
 *
 * ProgressBarWithSteps
 *
 */
import { Icon } from '../Icon';

import { Container, PillContainer, StepsContainer, ProgressText } from './styles';
import { Div } from 'styles/__layout';

interface Props {
  value: number;
  max: number;
  color: string;
  width: string;
  steps?: string[];
}

const ProgressBarWithSteps = ({ value, max, color, width, steps }: Props) => {
  return (
    <>
      <Container color={color} width={width}>
        <progress value={value} max={max} />
      </Container>
      {steps && steps.length > 0 && (
        <StepsContainer>
          {steps?.map((step, index) => (
            <Div
              key={index}
              display="flex"
              flexDirection="row"
              alignItems="center"
              justifyContent="center"
              width="100%"
            >
              <PillContainer active={value === index} completed={value >= index + 1}>
                {value >= index + 1 ? <Icon icon="check" /> : index + 1}
              </PillContainer>
              <ProgressText active={value === index}>{step}</ProgressText>
            </Div>
          ))}
        </StepsContainer>
      )}
    </>
  );
};

export default ProgressBarWithSteps;
